import { Key } from 'lucide-react'
import Panel from './Panel'
import AppSecretsSection from '../AppSecretsSection'

interface SecretsPanelProps {
  appName: string
  closeable?: boolean
  isMaximized?: boolean
  onClose?: () => void
  onMaximize?: () => void
}

/**
 * Workspace panel that surfaces the App Details secrets manager inline so
 * agents and users can declare/configure secrets without leaving the
 * workspace shell. Renders the EXACT same component as the App Details page;
 * one source of truth for the UX.
 */
export default function SecretsPanel({
  appName,
  closeable = true,
  isMaximized,
  onClose,
  onMaximize,
}: SecretsPanelProps) {
  return (
    <Panel
      title="App secrets"
      icon={<Key className="w-4 h-4" />}
      closeable={closeable}
      isMaximized={isMaximized}
      onClose={onClose}
      onMaximize={onMaximize}
    >
      {/* `h-full` (not `flex-1`) because Panel's inner content area is
          `overflow-hidden` but NOT a flex container, so flex-1 here would
          size to content and the secrets list would clip after the first
          row. h-full fills the parent's clipped height and lets
          overflow-y-auto actually scroll the embedded section. */}
      <div className="h-full overflow-y-auto">
        <AppSecretsSection appName={appName} canManage variant="embedded" />
      </div>
    </Panel>
  )
}
